export interface DiaryState {
    diary: any;
    loading: boolean;
    message: string;
}

export enum DiaryActionType {
    START_REQUEST = "START_REQUEST",
    DIARY_LOADED = "DIARY_LOADED",
    FINISH_REQUEST = "FINISH_REQUEST",
}
